const servers = 20412;
const capacity = 23882.039999999997;
const countries = 148;
const locations = 194;
export { servers, capacity, countries, locations };
